// Test IDs for the LXRA Studios marketing site.
// Keys camelCase, values kebab-case `<feature>-<element>`.

export const NAV = {
  logo: 'nav-logo',
  home: 'nav-link-home',
  galleries: 'nav-link-galleries',
  services: 'nav-link-services',
  photographers: 'nav-link-photographers',
  howItWorks: 'nav-link-how-it-works',
  gearLibrary: 'nav-link-gear-library',
  journal: 'nav-link-journal',
  about: 'nav-link-about',
  contact: 'nav-link-contact',
  bookNow: 'nav-book-now-button',
  mobileToggle: 'nav-mobile-toggle',
};

export const HOME_PAGE = {
  hero: 'home-hero-section',
  heroViewGalleries: 'hero-view-galleries-button',
  heroBookNow: 'hero-book-now-button',
  highlightsStrip: 'service-highlights-strip',
  featuredGalleries: 'home-featured-galleries-section',
  viewAllGalleries: 'home-view-all-galleries-link',
  aboutPreview: 'about-preview-section',
  aboutLearnMore: 'about-preview-learn-more-link',
  ctaBanner: 'home-cta-banner',
  ctaBookNow: 'home-cta-book-now-button',
};

export const GALLERIES_PAGE = {
  root: 'galleries-overview-page',
  grid: 'galleries-grid',
  card: (slug) => `gallery-category-card-${slug}`,
};

export const GALLERY_DETAIL_PAGE = {
  root: 'gallery-detail-page',
  backLink: 'gallery-detail-back-link',
  grid: 'gallery-detail-grid',
  image: (idx) => `gallery-image-open-button-${idx}`,
  lockedPanel: 'gallery-private-locked-panel',
  passcodeInput: 'gallery-private-passcode-input',
  passcodeSubmit: 'gallery-private-passcode-submit',
  passcodeError: 'gallery-private-passcode-error',
};

export const JOURNAL_PAGE = {
  root: 'journal-overview-page',
  grid: 'journal-grid',
  card: (slug) => `journal-post-card-${slug}`,
};

export const JOURNAL_POST_PAGE = {
  root: 'journal-post-page',
  backLink: 'journal-post-back-link',
};

export const NEWSLETTER = {
  form: 'newsletter-signup-form',
  input: 'newsletter-email-input',
  submitButton: 'newsletter-submit-button',
  statusText: 'newsletter-status-text',
};

export const MOBILE_QUICK_BAR = {
  root: 'mobile-quick-bar',
  call: 'mobile-quick-bar-call',
  message: 'mobile-quick-bar-message',
  bookNow: 'mobile-quick-bar-book-now',
};

export const LIGHTBOX = {
  dialog: 'lightbox-dialog',
  close: 'lightbox-close-button',
  next: 'lightbox-next-button',
  prev: 'lightbox-prev-button',
};

export const SERVICES_PAGE = {
  root: 'services-overview-page',
  grid: 'services-grid',
  card: (slug) => `service-card-${slug}`,
};

export const SERVICE_DETAIL_PAGE = {
  root: 'service-detail-page',
  backLink: 'service-detail-back-link',
  pricingSection: 'service-pricing-section',
  faqSection: 'service-faq-section',
  bookingButton: 'service-detail-booking-button',
};

export const ABOUT_PAGE = {
  root: 'about-page',
  statCard: (key) => `about-stat-${key}`,
  bookNow: 'about-book-now-button',
};

export const CONTACT_PAGE = {
  root: 'contact-page',
  form: 'contact-form',
  nameInput: 'contact-form-name-input',
  emailInput: 'contact-form-email-input',
  subjectInput: 'contact-form-subject-input',
  messageTextarea: 'contact-form-message-textarea',
  submitButton: 'contact-form-submit-button',
  statusText: 'contact-form-status-text',
};

export const FOOTER = {
  root: 'site-footer',
  bookNow: 'footer-book-now-button',
  instagram: 'footer-social-instagram',
  youtube: 'footer-social-youtube',
  tiktok: 'footer-social-tiktok',
  clientPortalLink: 'footer-client-portal-link',
  gearLibraryLink: 'footer-gear-library-link',
};

export const LOGIN_PAGE = {
  root: 'login-page',
  clientTab: 'login-tab-client',
  adminTab: 'login-tab-admin',
  emailInput: 'login-email-input',
  passwordInput: 'login-password-input',
  submitButton: 'login-submit-button',
  errorText: 'login-error-text',
  clientSignupLink: 'login-client-signup-link',
  photographerSignupLink: 'login-photographer-signup-link',
};

export const ADMIN_DASHBOARD = {
  root: 'admin-dashboard-page',
  logoutButton: 'admin-logout-button',
  tabOverview: 'admin-tab-overview',
  tabGalleries: 'admin-tab-galleries',
  tabJournal: 'admin-tab-journal',
  tabClients: 'admin-tab-clients',
  tabTeam: 'admin-tab-team',
  tabMessages: 'admin-tab-messages',
  tabNewsletter: 'admin-tab-newsletter',
  tabSettings: 'admin-tab-settings',
  createClientButton: 'admin-create-client-button',
  createGalleryButton: 'admin-create-gallery-button',
  createJournalButton: 'admin-create-journal-button',
  changePasswordForm: 'admin-change-password-form',
  galleriesTabBadge: 'admin-tab-galleries-badge',
  revisionAlertBanner: 'admin-revision-alert-banner',
  revisionAlertReviewButton: 'admin-revision-alert-review-button',
};

export const SHARE_REMINDERS = {
  card: 'admin-share-reminders-card',
  runButton: 'admin-share-reminders-run-button',
  resultText: 'admin-share-reminders-result-text',
  leadDaysSelect: 'admin-share-reminders-lead-days-select',
  leadDaysSave: 'admin-share-reminders-lead-days-save',
  leadDaysLabel: 'admin-share-reminders-lead-days-label',
};
